// Polite overdue-invoice reminder for company admins — never restricts access.
import React, { useState } from 'react';
import { Receipt, X } from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const money = (v) => `$${Number(v || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const OverdueBanner = () => {
  const { user } = useAuth();
  const inv = user?.overdue_invoice;
  const key = inv ? `overdue-dismissed-${inv.invoice_id}` : null;
  const [hidden, setHidden] = useState(() => (key ? sessionStorage.getItem(key) === '1' : true));
  if (!inv || hidden || user?.role === 'super_admin' || user?.impersonating) return null;

  const dismiss = () => { sessionStorage.setItem(key, '1'); setHidden(true); };
  const due = new Date(inv.due_date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  return (
    <div className="mx-3 sm:mx-6 mt-3 flex items-start gap-3 rounded-lg border border-amber-400/50 bg-amber-50 text-amber-900 dark:bg-amber-500/10 dark:text-amber-200 px-4 py-3 text-sm"
      role="status" data-testid="overdue-invoice-banner">
      <Receipt className="w-4 h-4 mt-0.5 shrink-0" />
      <div className="flex-1">
        <span className="font-medium">Friendly reminder:</span> invoice {inv.invoice_number} for {money(inv.balance)} was due on {due}
        {inv.days_overdue > 0 ? ` (${inv.days_overdue} day${inv.days_overdue === 1 ? '' : 's'} ago)` : ''}.
        {inv.grace_days_left > 0
          ? <>{' '}Access to paid modules stays on until <span className="font-medium">{new Date(inv.pauses_on).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}</span> ({inv.grace_days_left} day{inv.grace_days_left === 1 ? '' : 's'} left). Please arrange payment before then — reply to the invoice email if you have questions.</>
          : <>{' '}Please arrange payment to restore any paused modules — reply to the invoice email if you have questions.</>}
      </div>
      <button type="button" onClick={dismiss} aria-label="Dismiss" className="opacity-70 hover:opacity-100" data-testid="overdue-invoice-dismiss">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};
